import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['memory', 'slideshowMemory', 'video', 'modal'];

  disconnect() {
    this.close();
    this.modal = null;
    this.carousel = null;
  }

  close() {
    this.pause();
    this.modal?.hide();
  }

  open(event) {
    const items = this.slideshowMemoryTargets.map((el, position) => ({ position, el }));
    const index = this.memoryTargets.indexOf(event.currentTarget);
    if (!items.length || index < 0) return;

    // Stimulus targets reflect the current DOM, including newly uploaded memories.
    this.carousel = new Carousel(items);
    this.carousel.slideTo(index);

    // Turbo Stream inserts do not run Flowbite's data-modal-toggle initializer.
    // Own the modal here so every Stimulus-bound card can open it immediately.
    this.modal ||= new Modal(this.modalTarget);
    this.modal.show();
  }

  next() {
    this.carousel?.next();
    this.pause();
  }

  prev() {
    this.carousel?.prev();
    this.pause();
  }

  pause() {
    this.videoTargets.forEach(video => video.pause());
  }
}
